import { Breadcrumb } from '../../components/breadcrumbs/types';
import { AccountDetail, ProjectDetail } from '../../types';
import { paths } from '../../constants/paths';
import { NOT_DEFINED_SCORE_VALUE, SCORE_TO_COLOR } from '../../constants';

export const scopeTooltipText = (
  latestScopeAssessmentScore: number | undefined,
) =>
  `Scope: ${
    SCORE_TO_COLOR[latestScopeAssessmentScore ?? NOT_DEFINED_SCORE_VALUE]
  }`;

export const timelineTooltipText = (
  latestTimelineAssessmentScore: number | undefined,
) =>
  `Timeline: ${
    SCORE_TO_COLOR[latestTimelineAssessmentScore ?? NOT_DEFINED_SCORE_VALUE]
  }`;

export const getMyPortfolioBreadcrumbs = (
  account: AccountDetail,
  project: ProjectDetail | null,
): Breadcrumb[] => {
  const breadcrumbs = [
    {
      id: account.id,
      name: account.name,
      isAccessible: project ? true : false,
      path: `${paths.portfolio}/${account.id}`,
    },
  ];

  if (project) {
    breadcrumbs.push({
      id: project.id,
      name: project.name,
      isAccessible: false,
      path: `${paths.portfolio}/${account.id}/${project.id}`,
    });
  }

  return breadcrumbs;
};
